


































































import Vue from "vue";

export default Vue.extend({
  name: "TeaserTextLayer",
  props: {
    inverted: {
      type: Boolean,
      required: false,
    },
    size: {
      type: String,
      required: false,
    },
    badgeColor: {
      type: String,
      required: false,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    preline: {
      type: String,
      required: false,
    },
    headline: {
      type: String,
      required: true,
    },
    subline: {
      type: String,
      required: false,
    },
    badge: {
      type: String,
      required: false,
    },
    buttonClickFunction: {
      type: Function,
      required: false,
    },
    buttonText: {
      type: String,
      required: false,
    },
  },
});
